import { render, staticRenderFns } from "./ydView.vue?vue&type=template&id=4ddd31ce&scoped=true"
import script from "./ydView.vue?vue&type=script&lang=js"
export * from "./ydView.vue?vue&type=script&lang=js"
import style0 from "./ydView.vue?vue&type=style&index=0&id=4ddd31ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddd31ce",
  null
  
)

export default component.exports